import { render, staticRenderFns } from "./CANVariableItem.vue?vue&type=template&id=481e35b9&"
import script from "./CANVariableItem.vue?vue&type=script&lang=js&"
export * from "./CANVariableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports